import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { Category, StrapiListRequest, StrapiListResponse, StrapiResponse } from '@/interfaces/strapi';
import type { CategoryModel, StrapiResponseModel } from '@/interfaces/model';
import { categoryListMapper } from '@/mappers';

export const getCategory = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiResponse<Category>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/categorias',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<CategoryModel>;
					const mapped = categoryListMapper(json);
					const first = mapped.list[0];
					return { data: first } satisfies StrapiResponse<Category>;
				},
			],
		}),
		controller,
	};
};
